import DTSTAMP from './DTSTAMP'

/**
 * DTEND property.
 *
 * @see https://tools.ietf.org/html/rfc5545#section-3.8.2.2
 */
export default class DTEND extends DTSTAMP {
  static propName = 'DTEND'
}



/** WEBPACK FOOTER **
 ** ./src/properties/DTEND.js
 **/